var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeenFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 10.7117C20.9199 4.79886 16.4338 0 10.9062 0C5.3787 0 0.892578 4.79886 0.892578 10.7117C0.892578 15.8962 4.33728 20.2131 8.90351 21.2093V13.9253H6.90078V10.7117H8.90351V8.03381C8.90351 5.96644 10.4757 4.2847 12.4083 4.2847H14.9117V7.49822H12.909C12.3582 7.49822 11.9076 7.98025 11.9076 8.5694V10.7117H14.9117V13.9253H11.9076V21.3699C16.9645 20.8343 20.9199 16.2711 20.9199 10.7117Z",
    fill: "#58B310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeenFb);
export default __webpack_public_path__ + "static/media/geen_fb.ae0e33604853c468417aabb1d6025a04.svg";
export { ForwardRef as ReactComponent };